import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import {
  Close as CloseIcon,
  //   CheckCircleOutline as SuccessIcon,
  //   ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
// import { useSelector } from "react-redux";
// import {
//   selectWalletHasNfts,
//   selectWalletAddress,
// } from "../../wallets/walletsApiSlice";
// import { selectNftData, selectNftLoading } from "../../nfts/nftsApiSlice";
import Spinner from "../../../components/Spinner";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
// import PropertyForm from "../components/PropertyForm";
import {
  useGetMyPropertyByIdQuery,
  useUpdatePropertyMutation,
} from "../propertiesApiSlice";
// import UploadImageForm from "../../../components/forms/UploadImageForm";
// import LocationForm from "../../../components/forms/LocationForm";
// import UnitForm from "../../units/components/UnitForm";

import PropertyForm from "../components/PropertyFormPG";
import UnitForm from "../../units/components/UnitFormPG";
// import UploadImageForm from "../../../components/forms/UploadImageForm";
// import UploadImageForm2 from "../../../components/forms/UploadImageForm2";
import UploadImageForm from "../../../components/forms/UploadImageFormPG";
// import LocationForm from "../../../components/forms/LocationForm";
import LocationForm from "../../../components/forms/LocationFormPG";

import { useGetUnitTypesQuery } from "../../unitTypes/unitTypesApiSlice";
import { useGetUnitsQuery } from "../../units/api/unitsApiSlice";
import dayjs from "dayjs";

const steps = ["Property Details", "Location & Address", "Unit Details"];

const EditProperty = () => {
  const { id } = useParams();

  // --- 1. Queries ---
  //   const { data: property } = useGetMyPropertyByIdQuery(id);
  const {
    data: property,
    isLoading: isPropertyLoading, // Get the loading state
  } = useGetMyPropertyByIdQuery(id);

  const {
    data: unitsData,
    isLoading: isUnitsLoading,
    isSuccess: isUnitsSuccess,
  } = useGetUnitsQuery(property?.id, {
    skip: !property?.id, // Only skip if property ID is missing
  });

  const [updateProperty, { isLoading }] = useUpdatePropertyMutation();

  // Step State
  const [activeStep, setActiveStep] = useState(0);

  // Form Data State
  const [formData, setFormData] = useState({
    property: {
      title: "",
      propertyType: "",
      gender: "",
      tenantType: "",
      managerName: "",
      managerPhone: "",
      amenities: [],
      rules: [],
    },
    uploadImage: {
      images: [],
      mainImage: null,
    },
    location: {
      //   searchLocation: "",
      //   lat: "",
      //   lng: "",
      //   gpsLocation: "",
      //   gpsAddress: "",
      //   location: "",
      //   country: "",
      //   city: "",

      buildingName: "",
      streetAddress: "",
      area: "",
      countryId: "",
      stateId: "",
      cityId: "",
      cityName: "",
      pincode: "",
      lat: "",
      lng: "",
      nearestLandmark: "",
      landmarkDistance: "",
      transportTypeId: "",
      transportName: "",
      transportDistance: "",
    },
    unit: {
      unitType: "",
      //   totalBeds: 1, // Added based on previous context
      //   price: "",
      //   paymentFrequency: "",
      //   unitImages: [],
      //   unitMainImage: "",
      //   startDate: null,
      //   endDate: null,
      //   comments: "",
      // Add other unit fields if needed
      bathroomType: "", // Add default value
      size: "",
      amenities: [], // Add this
      //   foodIncluded: [], // Add this
      foodDetails: {
        isAvailable: false,
        dietaryPreference: "veg",
        mealsProvided: [],
      },
      price: "",
      securityDeposit: "",
      noticePeriod: "30", // Add default value
      //   startDate: null,
      //   endDate: null,
      unitImages: [],
      unitMainImage: null, // Changed from empty string to null
      comments: "",
    },
  });

  // Refs
  const propertyFormRef = useRef();
  const uploadImageFormRef = useRef();
  const locationFormRef = useRef();
  const unitFormRef = useRef();
  const errRef = useRef();
  const successRef = useRef();

  // API State
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // --- 3. Data Synchronization Effects ---

  // Sync Property Data
  // Sync Property & Location Data
  useEffect(() => {
    if (property) {
      setFormData((prev) => ({
        ...prev,
        property: {
          title: property.title || "",
          // Handle object or ID for propertyType
          propertyType: property?.propertyType._id || "",
          //   propertyType:
          //     property.propertyType?._id || property.propertyType || "",
          gender: property.gender || "",
          tenantType: property.tenantType || "",
          managerName: property.managerName || "",
          managerPhone: property.managerPhone || "",
          // Extract only _id strings so checkboxes work correctly
          // and safeParseIdArray on the backend can validate them
          amenities: (property.amenities || []).map((a) =>
            a?._id ? a._id.toString() : a,
          ),
          rules: (property.houseRules || []).map((r) =>
            r?._id ? r._id.toString() : r,
          ), // Backend sends 'houseRules', form expects 'rules'
        },
        uploadImage: {
          images: property.images || [],
          mainImage: property.mainImage || null,
        },
        location: {
          // Map nested backend address fields to flat form state
          buildingName: property.address?.buildingName || "",
          streetAddress: property.address?.street || "",
          area: property.address?.area || "",
          cityId: property.address?.city?._id || property.address?.city || null, // Handle populated vs unpopulated
          cityName:
            property.address?.city?.name || property.address?.city || "", // Handle populated vs unpopulated
          stateId:
            property.address?.state?._id || property.address?.state || "",
          pincode: property.address?.pincode || "",

          // Map Top-level Geo fields
          lat: property.lat || "",
          lng: property.lng || "",

          // Map Landmark & Transport
          nearestLandmark: property.nearestLandmark || "",
          landmarkDistance: property.landmarkDistance || "",
          transportTypeId: property.nearbyTransport?.[0]?.transportTypeId || "", // Adjust based on your specific Transport schema
          transportName: property.nearbyTransport?.[0]?.stationName || "",
          transportDistance:
            property.nearbyTransport?.[0]?.distanceMetres || "",
        },
      }));
    }
  }, [property]);

  //   useEffect(() => {
  //     if (property) {
  //       // setFormData({
  //       setFormData((prev) => ({
  //         ...prev,
  //         property: {
  //           // nft: property?.nftTokenId || "",
  //           title: property?.title || "",
  //           propertyType: property?.propertyType || "",
  //         },
  //         uploadImage: {
  //           images: property?.images || [],
  //           mainImage: property?.mainImage || null,
  //         },
  //         location: {
  //           searchLocation: property?.searchLocation || "",
  //           lat: property?.lat || "",
  //           lng: property?.lng || "",
  //           gpsLocation: property?.gpsLocation || "",
  //           gpsAddress: property?.gpsAddress || "",
  //           location: property?.location || "",
  //           country: property?.country || "",
  //           city: property?.city || "",
  //         },
  //       }));
  //     }
  //   }, [property]);

  // Sync Unit Data
  useEffect(() => {
    if (isUnitsSuccess && unitsData) {
      //   const unit = unitsData?.entities[unitsData.ids[0]] || {};
      // Get the first unit (assuming 1 unit per property for now, or edit logic needs specific unit ID)
      const unitId = unitsData.ids[0];
      const unit = unitsData.entities[unitId];

      if (unit) {
        setFormData((prev) => ({
          ...prev,
          unit: {
            // unitType: unit?.unitType || "",
            unitType:
              typeof unit.unitType === "object"
                ? unit.unitType._id
                : unit.unitType,
            bathroomType: unit.bathroomType || "",
            size: unit?.size || "",
            // bedrooms: unit?.bedrooms || "",
            // bathrooms: unit?.bathrooms || "",
            price: unit?.price || "",
            // paymentFrequency: unit?.paymentFrequency || "",
            securityDeposit: unit.securityDeposit || "",
            noticePeriod: unit.noticePeriodDays || "30",
            amenities: unit.amenities || [],
            foodDetails: unit.foodDetails || {
              isAvailable: false,
              dietaryPreference: "veg",
              mealsProvided: [],
            },
            unitImages: unit?.images || [],
            unitMainImage: unit?.mainImage || null,
            // startDate:
            //   unit?.availabilityDates?.length > 0 &&
            //   !!unit.availabilityDates[0]?.startDate
            //     ? dayjs(unit.availabilityDates[0].startDate)
            //     : null,
            // endDate:
            //   unit.availabilityDates?.length > 0 &&
            //   !!unit.availabilityDates[0]?.endDate
            //     ? dayjs(unit.availabilityDates[0].endDate)
            //     : null,
            comments: unit?.comments || "",
          },
        }));
      }
    }
  }, [isUnitsSuccess, unitsData]);

  const propertyType = formData.property?.propertyType;

  const {
    // Getting data and renaming it to propertyTypes
    data: fetchedUnitTypes,
    isLoading: isUnitTypeLoading,
    isError: isUnitTypeError,
  } = useGetUnitTypesQuery(propertyType, {
    skip: !propertyType, // Skip query if propertyType is empty
  });

  // useEffect(() => {
  //   window.scrollTo({ top: 0, left: 0 });
  // }, []);

  // Auto-focus error/success
  useEffect(() => {
    if (errMsg && errRef.current) errRef.current.focus();
    if (success && successRef.current) successRef.current.focus();
  }, [errMsg, success]);

  // Handle Data Updates
  const handleDataChange = (section, data) => {
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], ...data },
    }));
  };

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  // --- NAVIGATION LOGIC ---

  const handleNext = () => {
    let isValid = false;

    // Step 0: Property Info + Images
    if (activeStep === 0) {
      const isPropertyValid = propertyFormRef.current?.validateUserInput();
      if (!isPropertyValid) {
        return;
      }

      const isImageValid = uploadImageFormRef.current?.validateUserInput();
      if (!isImageValid) {
        return;
      }

      isValid = true;
    }
    // Step 1: Location
    else if (activeStep === 1) {
      const isLocationValid = locationFormRef.current?.validateUserInput();
      if (isLocationValid) {
        isValid = true;
      }
    }
    // Step 2: Unit (Handled by handleSubmit)
    else if (activeStep === 2) {
      isValid = true;
    }

    if (isValid) {
      setActiveStep((prevStep) => prevStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // --- SUBMISSION LOGIC ---

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. CLEAR ERRORS IMMEDIATELY
    // This removes the old alert box as soon as the user clicks the button.
    setErrMsg("");
    setSuccess(false); // Optional: clear success state if you allow re-submissions
    setIsSubmitted(true);

    // Final Validation (Unit Form)
    const isUnitValid = unitFormRef.current?.validateUserInput();
    if (!isUnitValid) return;

    // Prepare FormData
    const formDataToSubmit = new FormData();

    // --- 0. ID (CRITICAL FOR EDIT) ---
    formDataToSubmit.append("id", id);

    // --- 1. PROPERTY DATA ---
    formDataToSubmit.append("title", formData.property.title);
    formDataToSubmit.append("propertyType", formData.property.propertyType);
    formDataToSubmit.append("gender", formData.property.gender);
    formDataToSubmit.append("tenantType", formData.property.tenantType);
    formDataToSubmit.append("managerName", formData.property.managerName);
    formDataToSubmit.append("managerPhone", formData.property.managerPhone);

    // Arrays as JSON
    formDataToSubmit.append(
      "amenities",
      JSON.stringify(formData.property.amenities || []),
    );
    formDataToSubmit.append(
      "rules",
      JSON.stringify(formData.property.rules || []),
    );

    // Helper to process images
    const processImages = ({
      originalMainImageId,
      originalImages,
      updatedMainImage,
      updatedImages,
      mainImageFieldName,
      imagesFieldName,
      metadataFieldName,
    }) => {
      let mainImageAction = "keep";

      // Handle Main Image
      if (updatedMainImage?.file instanceof File) {
        formDataToSubmit.append(mainImageFieldName, updatedMainImage.file);
        mainImageAction = "new";
      } else if (
        updatedMainImage?._id &&
        updatedMainImage?._id !== originalMainImageId
      ) {
        mainImageAction = "changed";
      }

      // Handle Additional Images
      const newImages = updatedImages
        .filter((img) => img.file instanceof File)
        .map((img) => img.file);
      newImages.forEach((file) =>
        formDataToSubmit.append(imagesFieldName, file),
      );

      // Collect metadata
      const keepIds = updatedImages
        .filter((img) => img._id)
        .map((img) => img._id);

      const deletedIds = originalImages.filter((id) => !keepIds.includes(id));

      formDataToSubmit.append(
        metadataFieldName,
        JSON.stringify({
          deletedImageIds: deletedIds,
          keepImageIds: keepIds,
          mainImageAction,
          mainImageId: updatedMainImage?._id,
          originalMainImageId,
        }),
      );
    };

    // === 1. Process Property Images ===
    processImages({
      originalMainImageId: property.mainImage?._id,
      originalImages: property.images?.map((img) => img._id) || [],
      updatedMainImage: formData.uploadImage?.mainImage,
      updatedImages: formData.uploadImage?.images || [],
      mainImageFieldName: "mainImage",
      imagesFieldName: "images",
      metadataFieldName: "propertyImageData",
    });

    // // Property Images - Only append if it's a new file (Blob/File object)
    // if (formData.uploadImage.mainImage?.file instanceof File) {
    //   formDataToSubmit.append("mainImage", formData.uploadImage.mainImage.file);
    // }
    // formData.uploadImage.images.forEach((image) => {
    //   if (image.file instanceof File) {
    //     formDataToSubmit.append("images", image.file);
    //   }
    // });

    // --- 2. LOCATION DATA ---
    formDataToSubmit.append("buildingName", formData.location.buildingName);
    formDataToSubmit.append("streetAddress", formData.location.streetAddress);
    formDataToSubmit.append("area", formData.location.area);
    formDataToSubmit.append("cityId", formData.location.cityId);
    formDataToSubmit.append("cityName", formData.location.cityName);
    formDataToSubmit.append("stateId", formData.location.stateId);
    formDataToSubmit.append("pincode", formData.location.pincode);
    formDataToSubmit.append("lat", formData.location.lat);
    formDataToSubmit.append("lng", formData.location.lng);
    formDataToSubmit.append(
      "nearestLandmark",
      formData.location.nearestLandmark,
    );
    formDataToSubmit.append(
      "landmarkDistance",
      formData.location.landmarkDistance,
    );

    // Transport Array
    if (formData.location.transportTypeId) {
      const transportArray = [
        {
          transportTypeId: formData.location.transportTypeId,
          stationName: formData.location.transportName,
          distanceMetres: formData.location.transportDistance,
        },
      ];
      formDataToSubmit.append(
        "nearbyTransport",
        JSON.stringify(transportArray),
      );
    } else {
      formDataToSubmit.append("nearbyTransport", JSON.stringify([]));
    }

    // --- 3. UNIT DATA ---
    formDataToSubmit.append("unitType", formData.unit.unitType);
    formDataToSubmit.append("bathroomType", formData.unit.bathroomType);
    formDataToSubmit.append("size", formData.unit.size);
    formDataToSubmit.append("price", formData.unit.price);
    formDataToSubmit.append("securityDeposit", formData.unit.securityDeposit);
    formDataToSubmit.append("noticePeriod", formData.unit.noticePeriod);
    formDataToSubmit.append("comments", formData.unit.comments);

    // Unit Arrays as JSON
    formDataToSubmit.append(
      "unitAmenities",
      JSON.stringify(formData.unit.amenities || []),
    );
    formDataToSubmit.append(
      "foodDetails",
      JSON.stringify(formData.unit.foodDetails || {}),
    );

    // === 2. Process Unit Images ===
    processImages({
      originalMainImageId: unitsData?.entities[unitsData.ids[0]].mainImage?._id,
      originalImages:
        unitsData?.entities[unitsData.ids[0]].images?.map((img) => img._id) ||
        [],
      updatedMainImage: formData.unit?.unitMainImage,
      updatedImages: formData.unit?.unitImages || [],
      mainImageFieldName: "unitMainImage",
      imagesFieldName: "unitImages",
      metadataFieldName: "unitImageData",
    });

    // // Unit Images - Only append new files
    // if (formData.unit.unitMainImage?.file instanceof File) {
    //   formDataToSubmit.append(
    //     "unitMainImage",
    //     formData.unit.unitMainImage.file,
    //   );
    // }
    // formData.unit.unitImages.forEach((unitImage) => {
    //   if (unitImage.file instanceof File) {
    //     formDataToSubmit.append("unitImages", unitImage.file);
    //   }
    // });

    try {
      const updatedProperty = await updateProperty(formDataToSubmit).unwrap();
      if (updatedProperty) {
        setSuccess(updatedProperty.id || id);
        // Do not reset step, let user see success message
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (err) {
      if (!err.status) {
        setErrMsg("No Server Response");
      } else {
        setErrMsg(err.data?.message || "Update failed");
      }
      setIsSubmitted(false);
    }
  };

  // --- RENDER CONTENT ---

  const renderStepContent = (step) => {
    // Create a key that changes when data arrives
    const dataLoadedKey = property ? "loaded" : "loading";
    const unitsLoadedKey = isUnitsSuccess ? "units-loaded" : "units-loading";

    switch (step) {
      case 0:
        return (
          <>
            <PropertyForm
              key={`prop-form-${dataLoadedKey}`}
              ref={propertyFormRef}
              initialData={formData.property}
              onDataChange={(data) => handleDataChange("property", data)}
            />
            <UploadImageForm
              key={`img-form-${dataLoadedKey}`}
              ref={uploadImageFormRef}
              initialData={formData.uploadImage}
              onDataChange={(data) => handleDataChange("uploadImage", data)}
              //   imageInfo={"Property exterior *"}
              imageInfo={"Property Photos"}
            />
          </>
        );
      case 1:
        return (
          <LocationForm
            key={`loc-form-${dataLoadedKey}`}
            ref={locationFormRef}
            initialData={formData.location}
            onDataChange={(data) => handleDataChange("location", data)}
          />
        );
      case 2:
        return (
          <UnitForm
            key={`unit-form-${unitsLoadedKey}`}
            ref={unitFormRef}
            unitTypes={fetchedUnitTypes}
            isLoading={isUnitTypeLoading}
            isError={isUnitTypeError}
            initialData={formData.unit}
            onDataChange={(data) => handleDataChange("unit", data)}
            parent={"Property Type"}
          />
        );
      default:
        return <Typography>Unknown Step</Typography>;
    }
  };

  // --- SUCCESS VIEW COMPONENT ---
  //   if (successPropertyId) {
  //     return (
  //       <Container maxWidth="sm" sx={{ mt: 8, mb: 5 }}>
  //         <Paper
  //           elevation={3}
  //           sx={{
  //             p: 5,
  //             display: "flex",
  //             flexDirection: "column",
  //             alignItems: "center",
  //             textAlign: "center",
  //             borderRadius: 3,
  //           }}
  //         >
  //           <SuccessIcon color="success" sx={{ fontSize: 80, mb: 2 }} />
  //           <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
  //             Success!
  //           </Typography>
  //           <Typography variant="body1" color="text.secondary" paragraph>
  //             Your property <strong>{formData.property.title}</strong> has been
  //             listed successfully.
  //           </Typography>

  //           <Divider sx={{ width: "100%", my: 3 }} />

  //           <Box
  //             sx={{
  //               display: "flex",
  //               flexDirection: "column",
  //               gap: 2,
  //               width: "100%",
  //             }}
  //           >
  //             <Button
  //               variant="contained"
  //               size="large"
  //               onClick={() => navigate(`/my-properties/${successPropertyId}`)} // Navigate to details
  //               endIcon={<ArrowForwardIcon />}
  //             >
  //               View Property
  //             </Button>
  //             <Button variant="outlined" onClick={() => navigate("/dashboard")}>
  //               Go to Dashboard
  //             </Button>
  //           </Box>
  //         </Paper>
  //       </Container>
  //     );
  //   }

  // If data is loading or property object is not yet populated
  if (isPropertyLoading || !property) {
    return <Spinner />;
  }

  return (
    <Container sx={{ mt: 5, mb: 5 }}>
      {/* Header */}
      <Typography variant="h4" component="h1" align="center" gutterBottom>
        Edit Property
      </Typography>

      {/* Stepper */}
      <Stepper
        activeStep={activeStep}
        // sx={{ mb: 4, pt: 3, pb: 5 }}
        sx={{ pt: 3, pb: 5 }}
        alternativeLabel
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Main Form Box */}
      <Box
        component="form"
        noValidate
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 3,
          maxWidth: 800,
          mx: "auto",
        }}
      >
        {/* Messages */}
        {errMsg && (
          <Alert
            severity="error"
            ref={errRef}
            tabIndex={-1}
            action={
              <IconButton
                size="small"
                onClick={() =>
                  //   setErrors((prev) => ({ ...prev, mainImage: false }))
                  setErrMsg("")
                }
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
            {errMsg}
          </Alert>
        )}
        {success && (
          <Alert severity="success" ref={successRef} tabIndex={-1}>
            Property updated successfully!{" "}
            <Link
              to={`/my-properties/${success}`}
              style={{ color: "inherit", fontWeight: "bold" }}
            >
              Click here to Review & Publish
            </Link>
          </Alert>
        )}

        <>
          {/* Form Content */}
          {renderStepContent(activeStep)}

          {/* Navigation Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
            }}
          >
            {activeStep !== 0 && (
              <Button onClick={handleBack} variant="outlined" color="inherit">
                Back
              </Button>
            )}

            {activeStep === steps.length - 1 ? (
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={isLoading || success}
                startIcon={
                  isLoading && <CircularProgress size={20} color="inherit" />
                }
              >
                {isLoading
                  ? "Updating..."
                  : success
                    ? "Property Updated"
                    : "Update Property"}
              </Button>
            ) : (
              <Button variant="contained" onClick={handleNext}>
                Next
              </Button>
            )}
          </Box>
        </>
      </Box>
    </Container>
  );
};

export default EditProperty;
